/** @type {import("@mui/material").SxProps<typeof import('@mui/material/styles').Theme>} */
const useStyles = theme => ({
  faqContainerSuperMain: {
    background: theme?.palette?.primary?.backgroundColor3,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: '2rem',
  },
  summaryContainer: {
    p: '2rem 0.94rem 1rem 1.625rem',
    [theme.breakpoints.down('sm')]: {
      p: '1.5rem 1rem',
    },
  },
  summaryItem: {
    p: '1rem 0 1rem 0',
    [theme.breakpoints.down('md')]: {
      p: '1rem 0.5rem 1rem 0',
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '0.5rem',
    // p: 2,
    textAlign: 'right',
    [theme.breakpoints.down('sm')]: {
      marginTop: 0,
      textAlign: 'center',
      p: '1.5rem 1.8rem 1.8rem 1.8rem',
    },
  },
  clearCartText: {
    cursor: 'pointer',
    color: theme.palette.primary.buttonColor,
    textDecoration: 'underline',
    textTransform: 'none',
    mr: 1,
  },
  clearCartItem: {
    display: 'contents',
    cursor: 'pointer',
    padding: '1px 8px 1px 4px',
  },
  clearCartIcon: {
    cursor: 'pointer',
    color: theme.palette.primary.buttonColor,
    textTransform: 'none',
    fontSize: 'medium',
    mr: '-.8rem',
  },
  cartTitle: {
    color: theme.palette.primary.textColor3,
    textAlign: 'left',
  },
  prepayCartTitle: {
    color: theme.palette.primary.textColor3,
    textAlign: 'center',
  },
  portingSwitch: {
    pt: 3,
  },
  clearCartContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    pr: 2,
    [theme.breakpoints.down('sm')]: {
      p: '1rem 1.5rem 0.5rem 1.5rem',
    },
  },

  enableCTA: {
    border: `0.1875rem solid ${theme.palette.primary.buttonColor}`,
    padding: '8px 24px',
    background: theme.palette.primary.buttonColor,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      border: `0.1875rem solid ${theme.palette.primary.buttonPrimaryHoverColor}`,
      background: theme.palette.primary.buttonPrimaryHoverColor,
      color: theme.palette.primary.contrastText,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },

  summaryCard: {
    height: 'fit-content',
    width: '100%',
    borderRadius: '10px',
    boxShadow: `0px 6px 6px -3px ${theme.palette.primary.boxShadow2Dark}, 0px 10px 14px 1px ${theme.palette.primary.boxShadow2Medium}, 0px 4px 18px 3px ${theme.palette.primary.boxShadow2Lite}`,
  },
  prepayTopUp: {
    height: 'fit-content',
    width: '100%',
    borderRadius: '10px',
    boxShadow: `0px 6px 6px -3px ${theme.palette.primary.boxShadow2Dark}, 0px 10px 14px 1px ${theme.palette.primary.boxShadow2Medium}, 0px 4px 18px 3px ${theme.palette.primary.boxShadow2Lite}`,
  },
  myCart: {
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'column',
    },
  },
  myCartSection: {
    p: 0,
  },
  summaryTitle: {
    mb: '2rem',
    [theme.breakpoints.down('sm')]: {
      mb: '1rem',
    },
  },
  prepayContainer: {
    p: '1rem 1.5rem',
    [theme.breakpoints.down('sm')]: {
      p: '1rem 1.5rem',
    },
    height: 'fit-content',
  },
  topUptitle: {
    color: theme?.palette?.primary?.textColor3,
  },
  topUpSubtitle: {
    color: theme?.palette?.primary?.textColor3,
    p: '1.5rem 0 1rem 0',
  },
  topUpButton: {
    gap: '1rem',
    textTransform: 'capitalize',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
  },
  nextDisablecta: {
    background: theme.palette.primary.buttonInactiveColor,
    color: theme.palette.secondary.contrastText,
    pointerEvents: 'none',
    boxShadow: `0px 3px 1px -2px ${theme.palette.primary.boxShadow}, 0px 2px 2px ${theme.palette.primary.boxShadow}, 0px 1px 5px ${theme.palette.primary.boxShadow}`,
  },
  topUpSelector: {
    width: '100%',
    '& .MuiToggleButtonGroup-grouped': {
      borderRadius: '4px',
      backgroundColor: theme.palette.secondary.contrastText,
      border: `0.063rem solid ${theme.palette.primary.textColor3}`,
      '&:hover': {
        backgroundColor: theme.palette.secondary.contrastText,
      },
      '&:not(:first-of-type)': {
        minWidth: '67px',
        borderRadius: '4px',
        color: theme.palette.secondary.contrastText,
        borderColor: theme.palette.primary.textColor3,
        border: `0.063rem solid ${theme.palette.primary.textColor3}`,
        [theme.breakpoints.down('lg')]: {
          minWidth: '49px',
        },
      },
      '&:first-of-type': {
        minWidth: '67px',
        borderRadius: '4px',
        border: `0.063rem solid ${theme.palette.primary.textColor3}`,
        [theme.breakpoints.down('lg')]: {
          minWidth: '49px',
        },
      },
    },
  },
  itemBox: {
    p: '0.5rem 1rem 0.5rem 1.75rem',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '93%',
      p: '8px 0',
    },
  },
  payAmount: {
    p: '1.5rem 1.875rem 0 0',
    [theme.breakpoints.down('sm')]: {
      p: '1.5rem 0 0 0',
    },
  },
  subText: {
    color: theme.palette.primary.textColor3,
  },
  contactNumber: {
    color: theme.palette.primary.textColor5,
    display: 'flex',
  },
  afterPriceContainer: {
    [theme.breakpoints.down('sm')]: {
      width: '75%',
    },
  },
  deleteIcon: {
    pt: '.7rem',
    mr: '-.2rem',
  },
  cartIcon: {
    display: 'flex',
    justifyContent: 'center',
  },
  emptyCartButton: {
    border: `0.1875rem solid ${theme.palette.primary.buttonColor}`,
    borderRadius: '0.375rem',
    width: '8.125rem',
    padding: '0.3125rem',
    background: theme.palette.primary.buttonColor,
    color: theme.palette.primary.contrastText,

    '&:hover': {
      border: `0.1875rem solid ${theme.palette.primary.buttonPrimaryHoverColor}`,
      background: theme.palette.primary.buttonPrimaryHoverColor,
      color: theme.palette.primary.contrastText,
      boxShadow: `0px 2px 4px -1px ${theme.palette.primary.boxShadow}, 0px 4px 5px  ${theme.palette.primary.boxShadow}, 0px 1px 10px  ${theme.palette.primary.boxShadow}`,
    },
  },
});

export default useStyles;
